module.exports = __webpack_public_path__ + "img/icon-order.2fd22ba6.svg";